// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__21QUc","additionalInfo":"AgreementModal_additionalInfo__1AH4X"};